import { 
    CREATERADIOLOGYBILL, 
    CREATERADIOLOGYBILLTEST, 
    CREATERADIOLOGYBILLTRANSACTION, 
    CREATERADIOLOGYTESTCOLLECTER, 
    CREATERADIOLOGYTESTPARAMETERVALUE, 
    DELETERADIOLOGYBILL, 
    DELETERADIOLOGYBILLTEST, 
    DELETERADIOLOGYBILLTRANSACTION, 
    DELETERADIOLOGYTESTCOLLECTER, 
    DELETERADIOLOGYTESTPARAMETERVALUE, 
    GETRADIOLOGYBILL, 
    GETRADIOLOGYBILLTEST, 
    GETRADIOLOGYBILLTRANSACTION, 
    GETRADIOLOGYTESTCOLLECTER, 
    GETRADIOLOGYTESTPARAMETERVALUE, 
    UPDATERADIOLOGYBILL,
    UPDATERADIOLOGYBILLTEST,
    UPDATERADIOLOGYBILLTRANSACTION,
    UPDATERADIOLOGYTESTCOLLECTER,
    UPDATERADIOLOGYTESTPARAMETERVALUE
 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATERADIOLOGYBILL:
            return {
                ...state,
                    radiologybillSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYBILL:
                return {
                        ...state,
                        radiologybillList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYBILL:
                return {
                        ...state,
                        radiologybillUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYBILL:
                 return {
                     ...state,
                     radiologybillDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGYBILLTEST:
            return {
                ...state,
                radiologybilltestSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYBILLTEST:
                return {
                        ...state,
                        radiologybilltestList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYBILLTEST:
                return {
                        ...state,
                        radiologybilltestUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYBILLTEST:
                 return {
                     ...state,
                     radiologybilltestDeleteStatus: action.payload.success,
                        }
                        
        case CREATERADIOLOGYTESTCOLLECTER:
            return {
                ...state,
                radiologytestcollectorSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYTESTCOLLECTER:
                return {
                        ...state,
                        radiologytestcollecterList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYTESTCOLLECTER:
                return {
                        ...state,
                        radiologytestcollecterUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYTESTCOLLECTER:
                 return {
                     ...state,
                     radiologytestcollecterDeleteStatus: action.payload.success,
                        }
        case CREATERADIOLOGYBILLTRANSACTION:
            return {
                ...state,
                    radiologybilltransactionSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYBILLTRANSACTION:
                return {
                        ...state,
                        radiologybilltransactionList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYBILLTRANSACTION:
                return {
                        ...state,
                        radiologybilltransactionUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYBILLTRANSACTION:
                 return {
                     ...state,
                     radiologybilltransactionDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGYTESTPARAMETERVALUE:
            return {
                ...state,
                    radiologytestparametervalueSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYTESTPARAMETERVALUE:
                return {
                        ...state,
                        radiologytestparametervalueList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYTESTPARAMETERVALUE:
                return {
                        ...state,
                        radiologytestparametervalueUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYTESTPARAMETERVALUE:
                 return {
                     ...state,
                     radiologytestparametervalueDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }